export function addMissingValue(aList, o, fieldDef) {
  var v = o.GetFieldValue(fieldDef);
  if (v == null) v = "";
  aList.push(v);
}
